export const defaultConfig = {
  apiUri: 'https://portal.sonifi.com/api/',
  debugEnabled: false,
  googleAnalyticsId: 'G-SL2RV0DGQ7',
  maintenanceMessage: '',
  oauthCredentials: {
    client: {
      oauth_token: 'mnI2c5O52l6sjyYgOl9rpnCL3IvFfkAsrJQhMcpf',
      oauth_token_secret: 'PZ2AR3dbTOHcVESkqd5lkMR80kmh2MtJ0zZRAI9b',
    },
  },
  publishingDisabled: false,
  staycastApiUri: '/cast-api/',
  staycastDashboardUri: 'https://portal.sonifi.com/sonicast-dashboard/',
  technicalSupportChat: {
    enabled: true,
    baseUri: 'https://home-c36.nice-incontact.com',
    poc: '775a7ec5-7f82-4dd2-a34b-2e4e9f86415a',
    bu: '4601221',
  },
  techPubsDocsUri: 'https://static.sonifi.com/kb/index.html',
};
